import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { Switch, Route, withRouter } from 'react-router-dom'

import { Slot, ErrorBoundary, CSSVariables, TargetingProvider } from '../components';

import { ViewMappingProvider  } from './ViewContainer'
import ViewContainer from './ViewContainer'

import { selectGame } from '../redux/game/actions'

import GameContext from './GameContext'

import Competition from '../competitions/Competition'
import Contests from '../competitions/Contests'
import AdPage from '../components/AdPage';
import PageAd from '../components/PageAd';
import useMediaQuery from '../hooks/useMediaQuery';


const ViewFantasyTeam = () => {
    const matches = useMediaQuery('screen and (min-width: 1024px)');

    if (typeof matches !== 'boolean')
        return null;

    const viewName = matches ? 'fantasyteam' : 'fantasyteam.mobile';

    return <ViewContainer key={ viewName } name={ viewName } /> ;

}

class Game extends React.PureComponent {
    constructor(props) {
        super(props);
        
    }

    componentDidMount() {
        
        this.props.selectGame(parseInt(this.props.match.params.gameId));
    }

    componentWillUnmount() {

    }


    render() {
        return (
            <GameContext.Consumer>
                
                {
                    ({ game, gameConfiguration }) => (
                            <CSSVariables className="game-wallpaper" vars={ (gameConfiguration && gameConfiguration.theme) || {} }>
                                { 
                                    game && gameConfiguration && 
                                        <div style={{ maxWidth : '1200px', margin : '0 auto' }}>
                                            
                                            <Slot location="content-top"></Slot>
                                            
                                            <ErrorBoundary>
                                                <ViewMappingProvider map={ gameConfiguration.viewMapping }>
                                                
                                                    <Switch>
                                                        <Route path="/:language/games/:gameSlug/:gameId/competitions/:competitionSlug/:competitionId" render={ () => <Competition /> } />
                                                        <Route path="/:language/games/:gameSlug/:gameId/competitions" exact={ true } render={ () => <ViewContainer name="competitions" /> } />
                                                        <Route path="/:language/games/:gameSlug/:gameId/contests" exact={ true } render={ () => <Contests /> } />
                                                        <Route path="/:language/games/:gameSlug/:gameId/fantasyteams/:fantasyTeamSlug-:fantasyteamId" render={ () => <ViewFantasyTeam /> } />
                                                        <Route render={ () => this.props.children } />
                                                    </Switch>

                                                </ViewMappingProvider>
                                            </ErrorBoundary>
                                            
                                            <Slot location="content-bottom"></Slot>


                                        </div>
                                }
                            </CSSVariables>
                    )
                }
                
            </GameContext.Consumer>
        )
    }
}


const mapStateToProps = () => ({});

function mapDispatchToProps(dispatch) {
    return {
   
        selectGame(gameId) {
            dispatch(selectGame(gameId));
        }

    }
}

Game.propTypes = {
    selectGame : PropTypes.func,
    match : PropTypes.object,
    game : PropTypes.object,
    isAuthenticated : PropTypes.bool,
    onSignin : PropTypes.func,
    gameId : PropTypes.number
}


export default 
    withRouter(
            connect(mapStateToProps, mapDispatchToProps)(Game)
    );